import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  () => {
    const sizePhoto = 1584;
    const sizeCardPhoto = 1040;

    const shimmer = {
      backgroundImage:
        "linear-gradient(to right, #ececec 0%, #ececec 45%, #f8f8f8 50%, #ececec 55%, #ececec 100%)",
      animationDuration: "2s",
      animationFillMode: "forwards",
      animationIterationCount: "infinite",
      animationTimingFunction: "linear",
    };

    const shimmerPhoto = {
      backgroundSize: sizePhoto,
      animationName: "$shimmerPhotoAnimation",
    };

    const shimmerCardPhoto = {
      backgroundSize: sizeCardPhoto,
      animationName: "$shimmerCardPhotoAnimation",
    };

    const shimmerCardText = {
      backgroundSize: sizeCardPhoto,
      animationName: "$shimmerCardTextAnimation",
    };

    const shimmerDescription = {
      backgroundSize: sizePhoto,
      animationName: "$shimmerDescriptionAnimation",
    };

    const shimmerFee = {
      backgroundSize: sizePhoto,
      animationName: "$shimmerFeeAnimation",
    };

    return {
      shimmer,
      shimmerPhoto,
      shimmerCardPhoto,
      shimmerCardText,
      shimmerDescription,
      shimmerFee,
      line: {
        ...shimmer,
        ...shimmerPhoto,
        height: 24,
        maxWidth: 307,
        width: "100%",
        margin: 16,
      },
      container: {
        boxSizing: "border-box",
        borderColor: "#cccccc",
        width: "100%",
        marginTop: 32,
      },
      cardContainer: {
        boxSizing: "border-box",
        padding: 16,
        borderWidth: 1,
        borderStyle: "solid",
        borderRadius: 4,
        borderColor: "#cccccc",
        width: "100%",
        display: "grid",
        gridAutoFlow: "column",
        gridTemplateColumns: "auto 2fr",
        columnGap: 24,
      },
      textContainer: {
        display: "flex",
        flexDirection: "column",
      },
      photo: {
        ...shimmer,
        ...shimmerPhoto,
        height: 165,
        width: 165,
      },
      description: {
        ...shimmer,
        ...shimmerDescription,
        height: 24,
        maxWidth: 100,
        width: "100%",
        marginBottom: 24,
      },
      title: {
        ...shimmer,
        ...shimmerDescription,
        height: 24,
        maxWidth: 180,
        width: "100%",
        marginBottom: 24,
      },
      cardContainerPudo: {
        boxSizing: "border-box",
        padding: 16,
        borderWidth: 1,
        borderStyle: "solid",
        borderRadius: 4,
        borderColor: "#cccccc",
        display: "grid",
        gridAutoFlow: "column",
        width: "100%",
        gridTemplateAreas: "'Photo Title Fee' 'Photo Description .'",
        gridTemplateColumns: "auto 2fr 1.25fr",
        columnGap: 24,
      },
      cardPhoto: {
        ...shimmer,
        ...shimmerCardPhoto,
        height: 90,
        width: 90,
        gridArea: "Photo",
      },
      cardTitle: {
        ...shimmer,
        ...shimmerCardText,
        height: 24,
        maxWidth: 307,
        width: "100%",
        gridArea: "Title",
        alignSelf: "start",
        justifySelf: "start",
      },
      cardFee: {
        ...shimmer,
        ...shimmerFee,
        height: 24,
        maxWidth: 72,
        width: "100%",
        alignSelf: "start",
        justifySelf: "end",
      },
      cardDescription: {
        ...shimmer,
        ...shimmerCardText,
        height: 24,
        maxWidth: 156,
        width: "100%",
        gridArea: "Description",
        alignSelf: "start",
        justifySelf: "start",
      },
      "@keyframes shimmerPhotoAnimation": {
        from: { backgroundPosition: "-1584px 0" },
        to: { backgroundPosition: "1584px 0" },
      },
      "@keyframes shimmerCardPhotoAnimation": {
        from: { backgroundPosition: "-1040px 0" },
        to: { backgroundPosition: "1040px 0" },
      },
      "@keyframes shimmerCardTextAnimation": {
        from: { backgroundPosition: "calc(-1040px - 140px) 0" },
        to: { backgroundPosition: "calc(1040px - 140px) 0" },
      },
      "@keyframes shimmerDescriptionAnimation": {
        from: { backgroundPosition: "calc(-1584px - 220px) 0" },
        to: { backgroundPosition: "calc(1584px - 220px) 0" },
      },
      "@keyframes shimmerFeeAnimation": {
        from: { backgroundPosition: "calc(-1040px - calc(520px - 100%)) 0" },
        to: { backgroundPosition: "calc(1040px - calc(520px - 100%)) 0" },
      },
    };
  },
  {
    name: "N0Skeleton",
  },
);

export { useStyles };
